import { MODERATIONS_ACTIONS,MODERATIONS_CREATE_UPDATE_ACTIONS,MODERATIONS_DELETE_ACTIONS } from "../../actionType/moderations";
import { MODERATIONS_INACTIVATE_ACTIONS } from "../../actionType/admin/postModerate";

const intialState = {
  moderationsList: [],
  isModerationsListLoader: false,
  isModerationsFormLoader:false,
  moderationsFormData:{},
  moderationsDeleteData:{},
  isModerationsDeleteLoader:false
};

export const moderationsReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case MODERATIONS_ACTIONS.MODERATIONS_REQUEST:
      return { ...state, isModerationsListLoader: false };
    case MODERATIONS_ACTIONS.MODERATIONS_RESPONSE:
      return {
        ...state,
        moderationsList: payload,
        isModerationsListLoader: true,
      };
    case MODERATIONS_ACTIONS.MODERATIONS_ERROR:
      return {
        ...state,
        moderationsList: payload,
        isModerationsListLoader: false,
      };

      // MODERATIONS_CREATE_UPDATE_ACTIONS
      case MODERATIONS_INACTIVATE_ACTIONS.MODERATIONS_INACTIVATE_REQUEST :
        // console.log('MODERATIONS_CREATE_UPDATE_REQUEST')
        return { ...state};
      case MODERATIONS_INACTIVATE_ACTIONS.MODERATIONS_INACTIVATE_RESPONSE :
        // console.log('MODERATIONS_CREATE_UPDATE_RESPONSE')
        return {
          ...state,
        };
      case MODERATIONS_INACTIVATE_ACTIONS.MODERATIONS_INACTIVATE_ERROR :
        // console.log('MODERATIONS_CREATE_UPDATE_ERROR')
        return {
          ...state,
        };
      // MODERATIONS_CREATE_UPDATE_ACTIONS
      case MODERATIONS_CREATE_UPDATE_ACTIONS.MODERATIONS_CREATE_UPDATE_REQUEST:
        console.log('MODERATIONS_CREATE_UPDATE_REQUEST')
        return { ...state, isModerationsFormLoader: true };
      case MODERATIONS_CREATE_UPDATE_ACTIONS.MODERATIONS_CREATE_UPDATE_RESPONSE:
        console.log('MODERATIONS_CREATE_UPDATE_RESPONSE')
        return {
          ...state,
          moderationsFormData: payload,
          isModerationsFormLoader: false,
        };
      case MODERATIONS_CREATE_UPDATE_ACTIONS.MODERATIONS_CREATE_UPDATE_ERROR:
        console.log('MODERATIONS_CREATE_UPDATE_ERROR')
        return {
          ...state,
          moderationsFormData: payload,
          isModerationsFormLoader: false,
        };


        // MODERATIONS_DELETE_ACTIONS
      case MODERATIONS_DELETE_ACTIONS.MODERATIONS_DELETE_REQUEST:
        console.log('MODERATIONS_CREATE_UPDATE_REQUEST')
        return { ...state, isModerationsDeleteLoader: true };
      case MODERATIONS_DELETE_ACTIONS.MODERATIONS_DELETE_RESPONSE:
        console.log('MODERATIONS_CREATE_UPDATE_RESPONSE')
        return {
          ...state,
          moderationsDeleteData: payload,
          isModerationsDeleteLoader: false,
        };
      case MODERATIONS_DELETE_ACTIONS.MODERATIONS_DELETE_ERROR:
        console.log('MODERATIONS_CREATE_UPDATE_ERROR')
        return {
          ...state,
          moderationsDeleteData: payload,
          isModerationsDeleteLoader: false,
        };


    default:
      return state;
  }
};
